import { Link } from "react-router";
import { useI18n } from "@wato/i18n/react";
import { useWorkspace } from "../../workspace/WorkspaceContext";
import { matchSettingsFields } from "./settings-search-index";

/** OWN-365: field-level hits under the settings search box; each jumps to `page#field`. */
export function SettingsFieldResults({ query }: { readonly query: string }) {
  const { t } = useI18n();
  const { workspace } = useWorkspace();
  const hits = matchSettingsFields(query, (key) => t(key));
  if (hits.length === 0) return null;
  return (
    <ul className="flex flex-col" data-testid="settings-field-results">
      {hits.map((e) => (
        <li key={e.id}>
          <Link
            to={`/w/${workspace.id}/${e.to}#${e.fieldId}`}
            data-testid={`settings-field-hit-${e.id}`}
            className="block rounded-md px-2 py-2 max-md:py-3 text-sm text-on-action-ghost hover:bg-surface-sunken"
          >
            {t(e.labelKey)}
          </Link>
        </li>
      ))}
    </ul>
  );
}
